import { defineStore } from 'pinia';
import { useKeycloakStore } from './keycloak.js';

const path = import.meta.env.VITE_APP_URL + 'post';

export const usePostStore = defineStore('post', {
  state: () => ({
    msgCltConnected: false,
    messageSocketClient: '',
    deviceToken: '',
    post: '',
    postList: [],
    userPostList: [],
    groupPostList: [],
    comment: '',
    selectedGroup: '',
  }),
  persist: true,

  actions: {
    msgConnectSocketed(msgCltConnected) {
      this.msgCltConnected = msgCltConnected;
      console.log('msgConnectSocketed', msgCltConnected);
    },

    msgConnectSocketClient(messageSocketClient) {
      this.messageSocketClient = messageSocketClient;
      console.log('msgConnectSocketedclient', messageSocketClient);
    },

    setSelectedGroup(group) {
      this.selectedGroup = group;
      console.log('setSelectedGroup', group);
    },

    async createPost(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data } = await axios({
          url: `${path}/create`,
          method: 'POST',
          data: payload,
          headers: {
            Authorization: `Bearer ${useKeycloakStore().token}`,
          },
        });
        this.post = data;
      } catch (err) {
        console.log(err.response.data);
      }
    },

    async publishPost(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data } = await axios({
          url: `${path}/publish`,
          method: 'PUT',
          params: {
            postId: payload.postId,
            isPosted: payload.isPosted,
          },
          headers: {
            Authorization: `Bearer ${useKeycloakStore().token}`,
          },
        });
        this.post = data;
      } catch (err) {
        console.log(err.response.data);
      }
    },

    async canComment(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data } = await axios({
          url: `${path}/publish`,
          method: 'PUT',
          params: {
            postId: payload.postId,
            canComment: payload.canComment,
          },
          headers: {
            Authorization: `Bearer ${useKeycloakStore().token}`,
          },
        });
        this.post = data;
      } catch (err) {
        console.log(err.response.data);
      }
    },

    async updatePost(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data } = await axios({
          url: `${path}/create`,
          method: 'PUT',
          data: payload.post,
          params: {
            postId: payload.postId,
          },
          headers: {
            Authorization: `Bearer ${useKeycloakStore().token}`,
          },
        });
        this.post = data;
      } catch (err) {
        console.log(err.response.data);
      }
    },

    async repostPost(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data } = await axios({
          url: `${path}/repost`,
          method: 'POST',
          data: payload.post,
          params: {
            postId: payload.postId,
          },
          headers: {
            Authorization: `Bearer ${useKeycloakStore().token}`,
          },
        });
        this.post = data;
      } catch (err) {
        console.log(err.response.data);
      }
    },

    async hidePost(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data } = await axios({
          url: `${path}/hide`,
          method: 'PUT',
          params: {
            postId: payload,
          },
          headers: {
            Authorization: `Bearer ${useKeycloakStore().token}`,
          },
        });
        this.hidePostLogic(data);
      } catch (err) {
        console.log(err.response.data);
      }
    },

    async reactToPost(payload) {
      const { default: axios } = await import('axios');
      try {
        await axios({
          url: `${path}/react`,
          method: 'PUT',
          data: payload.reaction,
          headers: {
            Authorization: `Bearer ${useKeycloakStore().token}`,
          },
        });
        this.reactPostLogic(payload);
      } catch (err) {
        console.log(err.response.data);
      }
    },

    async removeReaction(payload) {
      const { default: axios } = await import('axios');
      try {
        await axios({
          url: `${path}/unreact`,
          method: 'PUT',
          params: {
            reactionId: payload.reactionId,
            authorId: payload.authorId,
          },
          headers: {
            Authorization: `Bearer ${useKeycloakStore().token}`,
          },
        });
        this.unreactPostLogic(payload);
      } catch (err) {
        console.log(err.response.data);
      }
    },

    async getComments(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data } = await axios({
          url: `${path}/comments`,
          method: 'GET',
          params: {
            itemId: payload.itemId,
            maxSize: payload.maxSize,
            offset: payload.offset,
          },
          headers: {
            Authorization: `Bearer ${useKeycloakStore().token}`,
          },
        });
        this.addComment({ comments: data, itemType: payload.itemType, postId: payload.postId, itemid: payload.itemid });
      } catch (err) {
        console.log(err.response.data);
      }
    },

    async commentPost(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data } = await axios({
          url: `${path}/comment`,
          method: 'POST',
          data: payload.comment,
          params: {
            postId: payload.postId,
          },
          headers: {
            Authorization: `Bearer ${useKeycloakStore().token}`,
          },
        });
        this.post = data;
      } catch (err) {
        console.log(err.response.data);
      }
    },

    async subCommentPost(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data } = await axios({
          url: `${path}/sub_comment`,
          method: 'POST',
          data: payload.comment,
          params: {
            commentId: payload.commentId,
          },
          headers: {
            Authorization: `Bearer ${useKeycloakStore().token}`,
          },
        });
        this.post = data;
      } catch (err) {
        console.log(err.response.data);
      }
    },

    async updateComment(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data } = await axios({
          url: `${path}/comment/update`,
          method: 'POST',
          data: payload.comment,
          params: {
            commentId: payload.commentId,
          },
          headers: {
            Authorization: `Bearer ${useKeycloakStore().token}`,
          },
        });
        this.post = data;
      } catch (err) {
        console.log(err.response.data);
      }
    },

    async deleteComment(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data } = await axios({
          url: `${path}/comment/delete`,
          method: 'DELETE',
          params: {
            commentId: payload.commentId,
          },
          headers: {
            Authorization: `Bearer ${useKeycloakStore().token}`,
          },
        });
        this.post = data;
      } catch (err) {
        console.log(err.response.data);
      }
    },

    async getPostList(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data } = await axios({
          url: `${path}/posts`,
          method: 'GET',
          headers: {
            Authorization: `Bearer ${useKeycloakStore().token}`,
          },
          params: {
            maxSize: payload.maxSize,
            offset: payload.offset,
          },
        });
        this.postList = this.postList.push(...data);
      } catch (err) {
        console.log(err);
      }
    },

    async getUserCreatedPost(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data } = await axios({
          url: `${path}/user/posts`,
          method: 'GET',
          headers: {
            Authorization: `Bearer ${useKeycloakStore().token}`,
          },
          params: {
            maxSize: payload.maxSize,
            offset: payload.offset,
          },
        });
        this.userPostList.push(data);
      } catch (err) {
        console.log(err.response.data);
      }
    },

    async getGroupCreatedPost(payload) {
      const { default: axios } = await import('axios');
      try {
        const { data } = await axios({
          url: `${path}/group/posts`,
          method: 'GET',
          headers: {
            Authorization: `Bearer ${useKeycloakStore().token}`,
          },
          params: {
            maxSize: payload.maxSize,
            offset: payload.offset,
            groupId: payload.groupId,
          },
        });
        this.groupPostList.push(data);
      } catch (err) {
        console.log(err.response.data);
      }
    },

    async deletePost(payload) {
      const { default: axios } = await import('axios');
      try {
        await axios({
          url: `${path}/delete`,
          method: 'PUT',
          params: {
            postId: payload,
          },
          headers: {
            Authorization: `Bearer ${useKeycloakStore().token}`,
          },
        });
        const criteria = {
          postId: payload,
          userId: useKeycloakStore().subject,
        };
        this.deletePostLogic(criteria);
      } catch (err) {
        console.log(err);
      }
    },

    updatePostList(payload) {
      const index = this.postList.findIndex(
        (post) => post.id === payload.id
      );
      if (index > -1) {
        this.postList.splice(index, 1, payload);
      } else {
        this.postList.unshift(payload);
      }
    },

    updateCommentList(payload) {
      const postIndex = this.postList.findIndex(
        (post) => post.id === payload.postId
      );
      if (postIndex > -1) {
        const commentIndex = this.postList[postIndex].comments.findIndex(
          (comment) => comment.id === payload.comment.id
        );
        if (commentIndex > -1) {
          this.postList[postIndex].comments.splice(commentIndex, 1, payload);
        } else {
          this.postList[postIndex].comments.unshift(payload);
        }
      }
    },

    addComment(payload) {
      const postIndex = this.postList.findIndex(
        (post) => post.id === payload.postId
      );
      if (payload.itemType === 'post') {
        if (postIndex > -1) {
          this.postList[postIndex].comments.push(...payload.comments);
        }
      } else if (payload.itemType === 'comment') {
        const commentIndex = this.postList[postIndex].comments.findIndex(
          (comment) => comment.id === payload.itemid
        );
        this.postList[postIndex].comments[commentIndex].replies.push(
          ...payload.comments
        );
      }
    },

    hidePostLogic(criteria) {
      const index = this.postList.findIndex(
        (post) => post.id === criteria.postId
      );
      if (index > -1) {
        const updatedPost = {
          ...this.postList[index],
          hidden: hidden.push(criteria.userId),
        };
        this.postList.splice(index, 1, updatedPost);
      }
    },

    deletePostLogic(criteria) {
      const index = this.postList.findIndex(
        (post) => post.id === criteria.postId
      );
      if (index > -1) {
        const updatedPost = {
          ...this.postList[index],
          has_deleted: has_deleted.push(criteria.userId),
        };
        this.postList.splice(index, 1, updatedPost);
      }
    },

    reactPostLogic(payload) {
      if (payload.itemType === 'post') {
        const index = this.postList.findIndex(
          (post) => post.id === payload.postId
        );
        if (index > -1) {
          const reactionIndex = this.postList[index].reactions.findIndex(
            (reaction) =>
              reaction.reactionType === payload.reaction.reactionType
          );
          if (reactionIndex > -1) {
            this.postList[index].reactions[reactionIndex].count += 1;
            this.postList[index].reactions[reactionIndex].users.push(
              payload.reaction.users[0]
            );
            this.postList[index].reactions[reactionIndex].authors.push(
              payload.reaction.authors[0]
            );
            console.log(
              'Reaction already exists, updated count',
              this.postList[index].reactions[reactionIndex]
            );
            return;
          }
          this.postList[index].reactions.push(payload.reaction);
          console.log('New reaction added', payload.reaction);
        }
      } else if (payload.itemType === 'comment') {
        const postIndex = this.postList.findIndex(
          (post) => post.id === payload.postId
        );
        if (postIndex > -1) {
          const commentIndex = this.postList[postIndex].comments.findIndex(
            (comment) => comment.id === payload.commentId
          );
          if (commentIndex > -1) {
            const reactionIndex = this.postList[postIndex].comments[
              commentIndex
            ].reactions.findIndex(
              (reaction) =>
                reaction.reactionType === payload.reaction.reactionType
            );
            if (reactionIndex > -1) {
              this.postList[postIndex].comments[commentIndex].reactions[
                reactionIndex
              ].count += 1;
              this.postList[postIndex].comments[commentIndex].reactions[
                reactionIndex
              ].users.push(payload.reaction.users[0]);
              this.postList[postIndex].comments[commentIndex].reactions[
                reactionIndex
              ].authors.push(payload.reaction.authors[0]);
              console.log(
                'Reaction already exists, updated count',
                this.postList[postIndex].comments[commentIndex].reactions[
                  reactionIndex
                ]
              );
              return;
            }
            this.postList[postIndex].comments[commentIndex].reactions.push(
              payload.reaction
            );
          }
        } else if (payload.itemType === 'sub_comment') {
          const postIndex = this.postList.findIndex(
            (post) => post.id === payload.postId
          );
          if (postIndex > -1) {
            const commentIndex = this.postList[postIndex].comments.findIndex(
              (comment) => comment.id === payload.commentId
            );
            if (commentIndex > -1) {
              const subCommentIndex = this.postList[postIndex].comments[
                commentIndex
              ].sub_comments.findIndex(
                (subComment) => subComment.id === payload.subCommentId
              );
              if (subCommentIndex > -1) {
                const reactionIndex = this.postList[postIndex].comments[
                  commentIndex
                ].sub_comments[subCommentIndex].reactions.findIndex(
                  (reaction) =>
                    reaction.reactionType === payload.reaction.reactionType
                );
                if (reactionIndex > -1) {
                  this.postList[postIndex].comments[
                    commentIndex
                  ].sub_comments[subCommentIndex].reactions[
                    reactionIndex
                  ].count += 1;
                  this.postList[postIndex].comments[
                    commentIndex
                  ].sub_comments[subCommentIndex].reactions[
                    reactionIndex
                  ].users.push(payload.reaction.users[0]);
                  this.postList[postIndex].comments[
                    commentIndex
                  ].sub_comments[subCommentIndex].reactions[
                    reactionIndex
                  ].authors.push(payload.reaction.authors[0]);
                  console.log(
                    'Reaction already exists, updated count',
                    this.postList[postIndex].comments[commentIndex]
                      .sub_comments[subCommentIndex].reactions[reactionIndex]
                  );
                  return;
                }
                this.postList[postIndex].comments[commentIndex].sub_comments[
                  subCommentIndex
                ].reactions.push(payload.reaction);
              } else {
                console.error(
                  'Sub-comment not found for reaction:',
                  payload.subCommentId
                );
              }
            } else {
              console.error(
                'Comment not found for reaction:',
                payload.commentId
              );
            }
          } else {
            console.error('Post not found for reaction:', payload.postId);
          }
        } else {
          console.error(
            'Unknown itemType in reactToPost:',
            payload.itemType
          );
        }
        console.log(
          'react to post',
          payload.reaction,
          this.postList[0]?.reactions
        );
      }
    },

    unreactPostLogic(payload) {
      if (payload.itemType === 'post') {
        const index = this.postList.findIndex(
          (post) => post.id === payload.postId
        );
        if (index > -1) {
          const reaction = this.postList[index].reactions.find(
            (reaction) => reaction.id === payload.reactionId
          );
          if (!reaction) {
            console.error(
              'Reaction not found for unreact:',
              payload.reactionId
            );
            return;
          }
          const userIndex = reaction.users.findIndex(
            (user) => user.userId === payload.userId
          );
          if (userIndex > -1) {
            this.postList[index].reactions = this.postList[
              index
            ].reactions.map((r) => {
              if (r.id === payload.reactionId) {
                r.users = r.users.filter(
                  (user) => user.userId !== reaction.users[0]
                );
                r.authors = r.authors.filter((author) => {
                  if (reaction.authors[0].groupId !== null) {
                    author.groupId !== reaction.authors[0].groupId;
                  } else {
                    author.userId !== reaction.authors[0].userId;
                  }
                });
                r.count--;
              }
              return r;
            });
            if (reaction.count <= 1) {
              this.postList[index].reactions = this.postList[
                index
              ].reactions.filter((r) => r.id !== payload.reaction.id);
            }
          }
        }
      } else if (payload.itemType === 'comment') {
        const postIndex = this.postList.findIndex(
          (post) => post.id === payload.postId
        );
        if (postIndex > -1) {
          const commentIndex = this.postList[postIndex].comments.findIndex(
            (comment) => comment.id === payload.commentId
          );
          if (commentIndex > -1) {
            const reaction = this.postList[postIndex].comments[
              commentIndex
            ].reactions.find(
              (reaction) => reaction.id === payload.reaction.id
            );
            if (!reaction) {
              console.error(
                'Reaction not found for unreact:',
                payload.reactionId
              );
              return;
            }
            const userIndex = reaction.users.findIndex(
              (user) => user.userId === payload.users[0].userId
            );
            if (
              reaction.users.length > 0 &&
              reaction.users.find(
                (user) =>
                  user.userId === useKeycloakStore().subject
              )
            ) {
              this.postList[postIndex].comments[commentIndex].reactions =
                this.postList[postIndex].comments[
                  commentIndex
                ].reactions.map((r) => {
                  if (r.id === payload.reactionId) {
                    r.users = r.users.filter(
                      (user) =>
                        user.userId !== useKeycloakStore().subject
                    );
                    r.count--;
                  }
                  return r;
                });
              if (reaction.count <= 1) {
                this.postList[postIndex].comments[commentIndex].reactions =
                  this.postList[postIndex].comments[
                    commentIndex
                  ].reactions.filter((r) => r.id !== payload.reactionId);
              }
            }
          } else {
            console.error(
              'Comment not found for unreact:',
              payload.commentId
            );
          }
        } else {
          console.error('Post not found for unreact:', payload.postId);
        }
        if (payload.itemType === 'sub_comment') {
          const postIndex = this.postList.findIndex(
            (post) => post.id === payload.postId
          );
          if (postIndex > -1) {
            const commentIndex = this.postList[postIndex].comments.findIndex(
              (comment) => comment.id === payload.commentId
            );
            if (commentIndex > -1) {
              const subCommentIndex = this.postList[postIndex].comments[
                commentIndex
              ].sub_comments.findIndex(
                (subComment) => subComment.id === payload.subCommentId
              );
              if (subCommentIndex > -1) {
                const reaction = this.postList[postIndex].comments[
                  commentIndex
                ].sub_comments[subCommentIndex].reactions.find(
                  (reaction) => reaction.id === payload.reactionId
                );
                if (!reaction) {
                  console.error(
                    'Reaction not found for unreact:',
                    payload.reactionId
                  );
                  return;
                }
                if (
                  reaction.users.length > 0 &&
                  reaction.users.find(
                    (user) =>
                      user.userId === useKeycloakStore().subject
                  )
                ) {
                  this.postList[postIndex].comments[
                    commentIndex
                  ].sub_comments[subCommentIndex].reactions = this.postList[
                    postIndex
                  ].comments[commentIndex].sub_comments[
                    subCommentIndex
                  ].reactions.map((r) => {
                    if (r.id === payload.reactionId) {
                      r.users = r.users.filter(
                        (user) =>
                          user.userId !== useKeycloakStore().subject
                      );
                      r.count--;
                    }
                    return r;
                  });
                  if (reaction.count <= 1) {
                    this.postList[postIndex].comments[
                      commentIndex
                    ].sub_comments[subCommentIndex].reactions =
                      this.postList[postIndex].comments[
                        commentIndex
                      ].sub_comments[subCommentIndex].reactions.filter(
                        (r) => r.id !== payload.reactionId
                      );
                  }
                }
              } else {
                console.error(
                  'Sub-comment not found for unreact:',
                  payload.subCommentId
                );
              }
            } else {
              console.error(
                'Comment not found for unreact:',
                payload.commentId
              );
            }
          } else {
            console.error('Post not found for unreact:', payload.postId);
          }
        } else {
          console.error(
            'Unknown itemType in unReactToPost:',
            payload.itemType
          );
        }
      }
      console.log(
        'unreact to post',
        payload.reaction,
        this.postList[0]?.reactions
      );
    },
  },
});
